import * as path from 'node:path';
import { forEachWithGitYield } from '../../git-runtime.js';
import { hydrateUnifiedPatchWithFileContext } from '../patch/hydrate/index.js';
import { unifiedDiffForFile } from '../patch/unified-diff-for-file.js';
import { resolveWorkingTreeFileTotalLines } from '../total-lines/resolve-changed-file-total-lines.js';
import type { WorkingTreeChangeFileRow } from '../types.js';
import { filePathRelativeToRepoRootFromWorkspace } from './file-path-relative-to-repo-root-from-workspace.js';

export async function enrichWorkingTreeFileRows(options: {
  rows: WorkingTreeChangeFileRow[];
  repoGitCwd: string;
  repoPathRelativeToWorkspaceRoot: string;
  binaryByPath: Set<string>;
}): Promise<void> {
  await forEachWithGitYield(options.rows, async (row) => {
    const filePathRelativeToRepoRoot = filePathRelativeToRepoRootFromWorkspace(
      row.workspaceRelPath,
      options.repoPathRelativeToWorkspaceRoot,
    );
    const filePath = path.join(options.repoGitCwd, filePathRelativeToRepoRoot);
    const hydrateKind = row.change === 'moved' ? 'modified' : row.change;
    let patch = await unifiedDiffForFile(
      options.repoGitCwd,
      filePathRelativeToRepoRoot,
      row.change,
      row.movedFromPathInRepo,
    );
    if (patch) {
      patch = await hydrateUnifiedPatchWithFileContext(
        patch,
        filePath,
        options.repoGitCwd,
        filePathRelativeToRepoRoot,
        hydrateKind,
      );
    }
    row.patchContent = patch;
    row.totalLines = await resolveWorkingTreeFileTotalLines({
      repoGitCwd: options.repoGitCwd,
      pathInRepo: filePathRelativeToRepoRoot,
      change: row.change,
      isBinary: options.binaryByPath.has(filePathRelativeToRepoRoot),
    });
  });
}
